import { FC } from "react";
import { FieldInput } from "@pepdirect/v3/ui/FieldInput";

export const PoNumberInput: FC = () => {
  return (
    <FieldInput
      label="Purchase order number (Optional)"
      name="poNumber"
      maxLength={25}
      // only allow alphanumeric and underscores
      parseFunc={(value) => value.replace(/[^A-Za-z0-9_]/g, "")}
    />
  );
};
